// The customer's signature accepting the work, as the office reads it (QA-727): on the job, the
// invoice and the customer's history. The words here; the pad is a short-lived signed link the
// server gives (signatures/shown.ts), never a public one.
import { dateTimeText } from '@flowology/kernel';

/** jobs.get's signatures and invoices.get's signature. */
export interface AcceptanceSignature {
  signatureId: string;
  invoiceId: string;
  invoiceNumber: string;
  jobId: string | null;
  signerName: string;
  signedAt: string;
  /** On the technician's iPad, or from the invoice's link. */
  channel: 'device' | 'portal';
  method: 'drawn' | 'typed';
  /** The pad; null until its file has arrived. */
  imageUrl: string | null;
}

/** "Signed to accept the work by Marco Bell, Oct 26, 10:10 a.m." (the year once it isn't this one). */
export function signedWords(
  s: Pick<AcceptanceSignature, 'signerName' | 'signedAt'>,
  timeZone: string,
  now = new Date(),
): string {
  // "10:10 a.m." already ends the sentence
  const when = dateTimeText(s.signedAt, timeZone, { year: false, now });
  return `Signed to accept the work by ${s.signerName}, ${when}${when.endsWith('.') ? '' : '.'}`;
}

/** Where they signed, with the invoice when the job has more than one to say which. */
export function signedWhere(
  s: Pick<AcceptanceSignature, 'channel' | 'method' | 'invoiceNumber'>,
  withInvoice = false,
): string {
  const where = s.channel === 'portal' ? 'From the invoice’s link' : 'On the technician’s iPad';
  const how = s.method === 'typed' ? ', typed' : '';
  return `${withInvoice ? `${s.invoiceNumber}. ` : ''}${where}${how}.`;
}

/** What shows where the pad isn't here yet (an iPad still sending it). */
export const PAD_ON_ITS_WAY = 'The signature itself isn’t here yet: the iPad sends it when it can.';
